import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filteredAccountsByNumber',
    standalone: false
})
export class FilteredAccountsByNumberPipe implements PipeTransform {
    static format(accountList: Record<string, any>[], startsWith: number, displayNumberOnly: boolean, PropertyNumberName = 'Numero'): Record<string, any>[] {
        return displayNumberOnly
            ? accountList.filter(account => account[PropertyNumberName].startsWith('' + startsWith))
            : accountList;
    }

    transform(accountList: Record<string, any>[], startsWith: number, displayNumberOnly: boolean, PropertyNumberName = 'Numero'): Record<string, any>[] {
        return FilteredAccountsByNumberPipe.format(accountList, startsWith, displayNumberOnly, PropertyNumberName);
    }
}
